import * as React from 'react';
import {RouteComponentProps} from 'react-router';

import {ErrorAlert} from '../common/ErrorAlert';
import {ErrorResponse, Returnal, SaveReturnalResponse} from '../api/dtos/dtos';
import furoApi from '../api/FuroApi';
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';
import ReturnDetailsEditor from './ReturnDetailsEditor';
import * as paths from '../paths';
import {showSaveConfirm, showSaveSuccessNotification} from "../utils/dialogs";
import {
  AlertController,
  bindAlertController,
  GlobalAlertContextConsumer
} from "../app/alert/GlobalAlertContextProvider";

interface CreateReturnPageState {
  editedReturnal?: Returnal;
  error?: ErrorResponse;
}

class CreateReturnPage extends React.Component<RouteComponentProps<{}>, CreateReturnPageState> {

  public readonly loadingHandler?: LoadingOverlayHandler;
  public readonly alertController?: AlertController;

  constructor(props: RouteComponentProps<{}>) {
    super(props);
    this.state = {};
  }

  public render() {
    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <GlobalAlertContextConsumer>
          {(state) => bindAlertController(state.checklist, this)}
        </GlobalAlertContextConsumer>

        <ReturnDetailsEditor
          mode="create"
          editable={true}
          showChecklist={false}
          returnal={this.state.editedReturnal}
          onReturnalChange={this.onReturnalChange}
          onSubmit={this.onFormSubmit}
          onCancel={this.onFormCancel}
        />

        {this.state.error && <ErrorAlert style={{marginTop: '16px'}} error={this.state.error}/>}
      </>
    );
  }

  private onReturnalChange = (returnal: Returnal) => {
    this.setState({editedReturnal: returnal,});
  };

  private onFormCancel = () => {
    this.props.history.goBack();
  };

  private onFormSubmit = () => {
    showSaveConfirm(this.saveFormValues);
  };

  private saveFormValues = () => {
    const {editedReturnal} = this.state;
    if (!editedReturnal) {
      return;
    }

    const promise = furoApi.returns.create(editedReturnal)
      .then(this.onSaveSuccess)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onSaveSuccess = (response: SaveReturnalResponse) => {
    showSaveSuccessNotification();
    this.alertController?.refreshAlertCount();
    this.props.history.replace(paths.viewReturnalPath(response.returnalId));
  }

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  }
}

export default CreateReturnPage;




// WEBPACK FOOTER //
// ./src/return-details/CreateReturnPage.tsx